module.exports = __webpack_public_path__ + "static/media/news_slider_phone2.5796a886.png";